import React from 'react';
import { Button } from '@mui/material';
import styled from 'styled-components';

/**
 * CustomButton 컴포넌트 Props
 * @typedef {Object} CustomButtonProps
 * @property {string} text - 버튼에 표시할 텍스트
 * @property {React.ReactNode} [icon] - 버튼 아이콘 (선택사항)
 * @property {Object} [buttonProps] - MUI Button의 추가 props
 */

const CustomButton = ({ text, icon, ...buttonProps }) => {
  return (
    <Wrapper>
      <Button {...buttonProps}>
        <>
          {icon && <span>{icon}</span>}
          {text}
        </>
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  span {
    text-transform: none;
    margin-right: 5px;
  }
`;

export default CustomButton;
